<template>
  <div class="turnstile-container">
    <div ref="turnstileElement" class="turnstile-widget"></div>
    <div v-if="error" class="turnstile-error">
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'TurnstileCaptcha',
  props: {
    siteKey: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      token: null,
      error: null,
      widgetId: null
    }
  },
  mounted() {
    this.loadTurnstile()
  },
  beforeUnmount() {
    if (this.widgetId) {
      window.turnstile?.remove(this.widgetId)
    }
  },
  methods: {
    loadTurnstile() {
      // Carrega o script do Cloudflare Turnstile
      if (window.turnstile) {
        this.initTurnstile()
        return
      }

      // Verifica se o script já foi carregado
      const existingScript = document.querySelector('script[src*="challenges.cloudflare.com/turnstile"]')
      if (existingScript) {
        existingScript.onload = () => {
          this.initTurnstile()
        }
        return
      }

      const script = document.createElement('script')
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js'
      script.async = true
      script.onload = () => {
        console.log('Turnstile script carregado com sucesso')
        this.initTurnstile()
      }
      script.onerror = (error) => {
        console.error('Erro ao carregar script do Turnstile:', error)
        this.error = 'Erro ao carregar o CAPTCHA. Verifique sua conexão com a internet.'
      }
      document.head.appendChild(script)
    },

    initTurnstile() {
      if (!window.turnstile) {
        this.error = 'CAPTCHA não disponível'
        return
      }

      if (!this.siteKey) {
        this.error = 'Chave do site não fornecida'
        return
      }

      console.log('Inicializando Turnstile com siteKey:', this.siteKey)

      try {
        this.widgetId = window.turnstile.render(this.$refs.turnstileElement, {
          sitekey: this.siteKey,
          callback: (token) => {
            console.log('Turnstile token recebido:', token)
            this.token = token
            this.error = null
            this.$emit('success', token)
          },
          'error-callback': (error) => {
            console.error('Erro no Turnstile:', error)
            this.error = 'Erro na validação do CAPTCHA'
            this.token = null
            this.$emit('error', error)
          },
          'expired-callback': () => {
            console.log('Token do Turnstile expirado')
            this.token = null
            this.$emit('expired')
          }
        })
        console.log('Turnstile widget criado com ID:', this.widgetId)
      } catch (err) {
        this.error = 'Erro ao inicializar o CAPTCHA'
        console.error('Turnstile error:', err)
      }
    },

    reset() {
      if (this.widgetId && window.turnstile) {
        window.turnstile.reset(this.widgetId)
        this.token = null
        this.error = null
      }
    },

    getToken() {
      return this.token
    }
  }
}
</script>

<style scoped>
.turnstile-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 1rem 0;
}

.turnstile-widget {
  margin: 0.5rem 0;
}

.turnstile-error {
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.5rem;
  text-align: center;
}
</style>
